import { ArrowUpRight, GitBranch } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { SITE } from '@/lib/site';

export function Projects() {
  return (
    <section id="work" className="scroll-mt-20 border-t border-border/60">
      <div className="container py-20 md:py-28">
        <div className="mb-12 space-y-4">
          <p className="font-mono text-sm text-nostr">// selected work</p>
          <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            Things I've built
          </h2>
          <p className="max-w-2xl text-lg text-muted-foreground">
            A few projects I maintain or have poured significant time into. All open source — contributions welcome.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2">
          {SITE.projects.map((project) => (
            <a
              key={project.name}
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group block focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-xl"
            >
              <Card className="h-full transition-all duration-300 group-hover:-translate-y-1 group-hover:border-bitcoin/40 group-hover:shadow-lg group-hover:shadow-bitcoin/5">
                <CardHeader className="space-y-3">
                  <div className="flex items-start justify-between gap-4">
                    <h3 className="font-display text-xl font-semibold tracking-tight">
                      {project.name}
                    </h3>
                    <ArrowUpRight className="size-5 shrink-0 text-muted-foreground transition-all group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-bitcoin" />
                  </div>
                  <Badge variant="outline" className="w-fit rounded-full border-nostr/40 text-xs text-nostr">
                    {project.status}
                  </Badge>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p className="leading-relaxed text-muted-foreground">{project.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {project.tags.map((tag) => (
                      <Badge key={tag} variant="secondary" className="rounded-full font-mono text-xs">
                        {tag}
                      </Badge>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </a>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center gap-3 rounded-xl border border-dashed border-border p-6">
          <GitBranch className="size-5 shrink-0 text-muted-foreground" />
          <span className="text-sm text-muted-foreground">Also contributing to:</span>
          <div className="flex flex-wrap gap-2">
            {SITE.contributions.map((name) => (
              <Badge key={name} variant="outline" className="rounded-full font-mono text-xs">
                {name}
              </Badge>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
